import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=0f3c1956&scoped=true&lang=pug&"
import script from "./Delivery.vue?vue&type=script&lang=js&"
export * from "./Delivery.vue?vue&type=script&lang=js&"
import style0 from "./Delivery.vue?vue&type=style&index=0&id=0f3c1956&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3c1956",
  null
  
)

/* custom blocks */
import block0 from "./Delivery.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports